// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { Divider, Row } from '@paypalcorp/pp-react'
import ClickableRow from './components/clickable-row'

// HELPERS
import { useBizInfoRow, useDescriptionRow } from './hooks'

// STYLES
import styles from './styles.module.less'

/**
 * Displays rows showing the business description and contact info/location that also links
 * to edit pages for their respective content
 */
export default function BusinessInfoSection({
  isLoading,
}: Readonly<{ isLoading: boolean }>) {
  const clickableRows = [useDescriptionRow(), useBizInfoRow()]

  return (
    <Row noGutters className={styles.sectionContainer}>
      {clickableRows.map((props, index) => (
        <div key={index}>
          <ClickableRow {...props} isLoading={isLoading} />
          {index !== clickableRows.length - 1 && <Divider />}
        </div>
      ))}
    </Row>
  )
}
